import { Component, OnInit } from '@angular/core';
import { TasksServices } from '../tasks-services';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';


@Component({
  selector: 'app-new-task',
  templateUrl: './new-task.component.html',
  styleUrls: ['./new-task.component.css']
})
export class NewTaskComponent implements OnInit {

  constructor(private taskService: TasksServices, private router: Router) { }

  ngOnInit() {
  }

  onSave(newTaskForm: NgForm) {
    const date: Date = newTaskForm.value.date;
    const description = newTaskForm.value.description;
    this.taskService.CreateNew({code: null, createDate: date, description: description
    , comments: '', finished: false, updated: false, updatedDate: null, userName: '' });
    this.router.navigate(['/']);
  }

}



// WEBPACK FOOTER //
// ./src/app/tasks/new-task/new-task.component.ts